// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3X6kp","right":"styles_right__3eAcm"};